import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { initPx, loadAssets, prefetchLaunch } from './utils';
var Checkout = function Checkout(props) {
  var _window$px, _window$px$checkoutNa;
  var id = props.id,
    loadingSpinner = props.loadingSpinner,
    _props$checkoutName = props.checkoutName,
    checkoutName = _props$checkoutName === void 0 ? 'ExpressCart' : _props$checkoutName,
    launch = props.prefetchLaunch;
  var _useState = useState((_window$px = window.px) === null || _window$px === void 0 ? void 0 : (_window$px$checkoutNa = _window$px[checkoutName]) === null || _window$px$checkoutNa === void 0 ? void 0 : _window$px$checkoutNa.isCheckoutReady),
    _useState2 = _slicedToArray(_useState, 2),
    isCheckoutReady = _useState2[0],
    setIsCheckoutReady = _useState2[1];
  var containerId = 'checkout-cart';
  if (id) containerId = "".concat(containerId, "-").concat(id);
  useEffect(function () {
    initPx(_objectSpread({
      containerId: containerId
    }, props));
    var intervalId = setInterval(function () {
      var _window$px$checkoutNa2;
      if (!window.px) return;
      if ((_window$px$checkoutNa2 = window.px[checkoutName]) !== null && _window$px$checkoutNa2 !== void 0 && _window$px$checkoutNa2.isCheckoutReady && !isCheckoutReady) {
        setIsCheckoutReady(true);
        clearInterval(intervalId);
      }
    }, 200);
    if (launch === true) {
      prefetchLaunch(props);
    }
    loadAssets(props, intervalId);
    return function () {
      if (window.px) {
        window.px.isLoadingAssets = false;
      }
      clearInterval(intervalId);
    };
  }, []);
  useEffect(function () {
    var _window$px2, _window$px2$checkoutN;
    if ((_window$px2 = window.px) !== null && _window$px2 !== void 0 && (_window$px2$checkoutN = _window$px2[checkoutName]) !== null && _window$px2$checkoutN !== void 0 && _window$px2$checkoutN.loadCheckout) {
      var _window$px3, _window$px3$checkoutN;
      window.px[checkoutName].loadCheckout(containerId, _objectSpread(_objectSpread({}, props), {}, {
        prefetchId: (_window$px3 = window.px) === null || _window$px3 === void 0 ? void 0 : (_window$px3$checkoutN = _window$px3[checkoutName]) === null || _window$px3$checkoutN === void 0 ? void 0 : _window$px3$checkoutN.prefetchId
      }));
    }
  }, [isCheckoutReady, checkoutName]);
  return /*#__PURE__*/React.createElement("div", {
    id: containerId
  }, loadingSpinner);
};
Checkout.propTypes = {
  appKey: PropTypes.string,
  checkoutName: PropTypes.string,
  id: PropTypes.string,
  loadingSpinner: PropTypes.object,
  onError: PropTypes.func,
  prefetchLaunch: PropTypes.bool
};
export default Checkout;
//# sourceMappingURL=Checkout.js.map